import React, {useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import OnlineStatus from '../OnlineStatus'

import './style.css';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import HomeIcon from '@mui/icons-material/Home';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {httpClient} from "../../core/HttpClient";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import AddressOriginDialog from "../AddressOriginDialog";
import Alert from "@mui/material/Alert";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// const GreenSwitch = withStyles({
//     switchBase: {
//         '&$checked': {
//             color: '#44cc00',
//         },
//         '&$checked + $track': {
//             backgroundColor: '#44cc00',
//         },
//     },
//     checked: {},
//     track: {},
// })(Switch);

const useStyles = makeStyles((theme) => ({
    root: {},
    list: {
        paddingTop: 0
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
}));

export default function Home() {
    const { t } = useTranslation();
    const [confirm, setConfirm] = useState(null);
    const classes = useStyles();
    const [openEditLocation, setOpenEditLocation] = useState(false);
    const [countPendingPayment, setCountPendingPayment] = useState(0);
    const [account, setAccount] = useState({
        _id: '',
        cid: '',
        name: {i18n: {en: '', th: ''}},
        address: {i18n: {en: '', th: ''}},
        phone: '',
        email: '',
        active: false,
        orderingType: 'inorder',
        image: {},
        images: [],
        times: [{
            weekdays: [],
            open: {hour: '00', minute: '00'},
            close: {hour: '00', minute: '00'}
        }]
    });
    const [loading, setLoading] = useState({init: false, update: false});

    useEffect(() => {
        console.log('[Home]');

        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me';
        const urlCount = process.env.REACT_APP_API_BASE_URL + '/accounts/me/bill/count/pending';
        let tasks = [httpClient.get(url), httpClient.get(urlCount)];
        Promise.all(tasks)
            .then(rs=>{
                if(rs[0] && rs[0].data){
                    setAccount(rs[0].data);
                }
                if(rs[1] && rs[1].data){
                    setCountPendingPayment(rs[1].data.pending);
                }
            })
            .catch(e=>{
                console.log('error', e);
            });

    }, []);

    const handleShopStatus = () => {
        setAccount({ ...account, 'active': confirm });
        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/' + account._id;
        httpClient.post(url, {'active': confirm})
            .then(res => {

            });
        setConfirm(null);
    }

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        if(newValue === 0) {
            window.location.href = '/home';
        } else if(newValue === 1) {
            window.location.href = '/orders';
        }
    };

    // const handleSwitchChange = ({ target }) => {
    //     setConfirm(target.checked);
    // };

    const handleClose = () => {
        setConfirm(null);
    };

    const handleCloseEditLocation = () => {
        setOpenEditLocation(false);
    };

    const handleSaveOriginLocation = (value) => {
        if(value){
            setAccount({ ...account, lat: value.lat, lng: value.lng});
            loading.update = true;
            const url = process.env.REACT_APP_API_BASE_URL + '/accounts/' + account._id;
            httpClient.post(url, {lat: value.lat, lng: value.lng})
                .then(res => {
                    setLoading({init: false, update: false});
                });
            setOpenEditLocation(false);
        }
    };

    return (
        <div className={classes.root}>
                <Box display="flex" justifyContent="space-between" alignItems="center" m={1}>
                    <Typography variant="h6">
                        {t('dashboard.title')}
                    </Typography>
                </Box>
                <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                {countPendingPayment > 0 &&
                    <Box p={1}>
                        <Alert severity="warning">
                            {t('account.paymentPendingMessage')}
                        </Alert>
                    </Box>
                }
                <form noValidate autoComplete="off">
                    <Box m={1}>
                        <OnlineStatus plan={account.plan} />
                    </Box>
                </form>
                <AddressOriginDialog
                    open={openEditLocation}
                    shop={account}
                    onClose={handleCloseEditLocation}
                    onSave={handleSaveOriginLocation}
                />
            {/*<Box display="flex" justifyContent="space-between" alignItems="center" m={1}>*/}
            {/*    <Typography variant="h6">*/}
            {/*        {t('dashboard.title')}*/}
            {/*    </Typography>*/}
            {/*</Box>*/}
            {/*<Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />*/}
            {/*<Box mt={2} m={1}>*/}
            {/*    <Card variant="outlined">*/}
            {/*        <Box m={2}>*/}
            {/*            {loading &&*/}
            {/*                <Box display="flex" justifyContent="center" m={2} pt={2}>*/}
            {/*                    <Chip label={t('common.loading')} icon={<CircularProgress size={20}/>}/>*/}
            {/*                </Box>*/}
            {/*            }*/}
            {/*            {!loading &&*/}
            {/*                <Box display="flex" justifyContent="center" m={2} pt={2}>*/}
            {/*                    {!account.active &&*/}
            {/*                        <Chip color="secondary" label={t('shop.status.close')} icon={<StoreIcon/>}/>*/}
            {/*                    }*/}
            {/*                    {account.active &&*/}
            {/*                        <Chip color="primary" label={t('shop.status.open')} icon={<StoreIcon/>}/>*/}
            {/*                    }*/}
            {/*                </Box>*/}
            {/*            }*/}
            {/*            <Box display="flex" justifyContent="center">*/}
            {/*                <GreenSwitch*/}
            {/*                    name="active"*/}
            {/*                    disabled={loading}*/}
            {/*                    checked={ account.active }*/}
            {/*                    onChange={ handleSwitchChange }*/}
            {/*                    color="primary"*/}
            {/*                    inputProps={{ 'aria-label': 'active' }}*/}
            {/*                />*/}
            {/*            </Box>*/}
            {/*            <Box mt={2}>*/}
            {/*                <ShopLink cid={account.cid} name="link" type="o" share={true}/>*/}
            {/*            </Box>*/}
            {/*        </Box>*/}
            {/*    </Card>*/}
            {/*</Box>*/}
            <Box mt={4}>
                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                    <BottomNavigation
                        showLabels
                        value={0}
                        onChange={handleChange}
                    >
                        <BottomNavigationAction label={t('dashboard.title')} icon={<HomeIcon />} />
                        <BottomNavigationAction label={t('orders.title')} icon={<ListAltIcon />} />
                    </BottomNavigation>
                </Paper>
            </Box>

            <Dialog
                open={confirm !== null}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{t('common.message.confirm')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {confirm?t('shop.statusConfirm.open'):t('shop.statusConfirm.close')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained"
                            onClick={handleClose}
                            fullWidth={true}
                            size="large"
                            color={"grey"}
                            disableElevation>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="contained"
                            size="large"
                            color={"primary"}
                            disableElevation
                            fullWidth={true}
                            onClick={ handleShopStatus }>
                        {t('common.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}